import { Skeleton } from '~/components/skeleton';

export const CollectionSkeleton = () => <Skeleton className="w-full h-[195px]" />;
